import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TourPopupLink } from '../components/TourPopupLink';
import { supabase, GuestbookEntryRow } from '../lib/supabase';
function formatDate(iso: string) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).toLowerCase();
  } catch {
    return '';
  }
}
export function Guestbook() {
  const [entries, setEntries] = useState<GuestbookEntryRow[]>([]);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const fetchEntries = async () => {
    setIsLoading(true);
    const {
      data,
      error
    } = await supabase.from('guestbook_entries').select('*').order('created_at', {
      ascending: false
    });
    if (error) {
      setErrorMsg(`could not load guestbook — ${error.message}`);
      setEntries([]);
    } else {
      setEntries(data || []);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchEntries();
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');
    const trimmedMsg = message.trim();
    if (!trimmedMsg) return;
    setIsSubmitting(true);
    const trimmedName = name.trim() || 'anon';
    const {
      error
    } = await supabase.from('guestbook_entries').insert([{
      name: trimmedName,
      message: trimmedMsg
    }]);
    if (error) {
      setErrorMsg(`could not save entry — ${error.message}`);
      setIsSubmitting(false);
      return;
    }
    setName('');
    setMessage('');
    setIsSubmitting(false);
    // Refresh the list so the new entry appears immediately
    await fetchEntries();
  };
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-198" data-mp="1phad9zbsgvtl">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-199" data-mp="w416hhtdvft7">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-200" data-mp="10uhm98kofdiq">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-201" data-mp="15tkqwrwqvhq6">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-202" data-mp="15tce100mgcez">
            catalog
          </Link>
          <TourPopupLink data-id="element-203" data-mp="1aqufk5cb7pcy" />
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-204" data-mp="1frs4r1vqljny">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-205" data-mp="1jtdc67pi55qr">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-206" data-mp="3hjwuq7toe6w1">
          contact
        </a>
      </header>

      {/* Sign form */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-207" data-mp="3e0xrbr8yoylu">
        <p className="mb-4 font-bold lowercase" data-id="element-208" data-mp="39ahb5zdrayvs">sign the guestbook</p>

        <form onSubmit={handleSubmit} className="flex w-full max-w-md flex-col gap-4" data-id="element-209" data-mp="3996a47bp458d">
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="name (optional)" disabled={isSubmitting} className="border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-210" data-mp="3491pc53r8occ" />

          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="leave a message" rows={3} required disabled={isSubmitting} className="resize-none border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-211" data-mp="3nyc51j3i39ag" />

          <button type="submit" disabled={isSubmitting} className="self-start lowercase text-black hover:opacity-60 disabled:opacity-40" data-id="element-212" data-mp="3vhbhhwvtykdz">
            {isSubmitting ? 'signing...' : 'sign'}
          </button>
        </form>

        {errorMsg && <p className="mt-3 lowercase text-black/50" data-id="element-213" data-mp="3qigx4qi7snrr">{errorMsg}</p>}
      </section>

      {/* Entries */}
      <section className="mt-16 flex w-full flex-col items-start gap-6 text-sm md:mt-20" data-id="element-214" data-mp="i36pz3zgwsd4">
        <p className="font-bold lowercase" data-id="element-215" data-mp="n1rp102zh5zz">entries</p>

        {isLoading ? <p className="lowercase text-black/50" data-id="element-216" data-mp="mznnupwgyl3e">loading...</p> : errorMsg ? <p className="lowercase text-black/50" data-id="element-217" data-mp="94cvbj5p6c27">{errorMsg}</p> : entries.length === 0 ? <p className="lowercase" data-id="element-218" data-mp="e3g2b958msct">no entries yet.</p> : entries.map(entry => <div key={entry.id} className="flex w-full max-w-md flex-col items-start gap-1" data-id="element-219" data-mp="2tukap503iy8m">
              <p className="font-bold lowercase" data-id="element-220" data-mp="2qa0otx6cdxgx">
                {entry.name}
                <span className="ml-2 font-normal text-black/40" data-id="element-221" data-mp="2m8ynnasv7bcb">
                  {formatDate(entry.created_at)}
                </span>
              </p>
              <p className="lowercase" data-id="element-222" data-mp="3087s5d7pkh0g">{entry.message}</p>
            </div>)}
      </section>

      <div className="h-24" data-id="element-223" data-mp="2vag0mkaz6wws" />
    </main>;
}